import gql from 'graphql-tag'

export const QUERY_CATEGORY_PRODUCT_COMPARISON_METRICS = gql`
  query productComparisonsMetrics(
    $referenceInitialDate: String!
    $referenceFinalDate: String!
    $currentInitialDate: String!
    $currentFinalDate: String!
    $metricName: ComparisonMetricName!
    $categories: [ID]
    $units: [UnitConfigurationInput]
    $page: Int
    $pageSize: Int
    $search: String
    $sort: [String]
    $sortDirection: [SortDirection]
  ) {
    productComparisonsMetrics(
      referenceInitialDate: $referenceInitialDate
      referenceFinalDate: $referenceFinalDate
      currentInitialDate: $currentInitialDate
      currentFinalDate: $currentFinalDate
      metricName: $metricName
      categories: $categories
      units: $units
      page: $page
      pageSize: $pageSize
      search: $search
      sort: $sort
      sortDirection: $sortDirection
    ) {
      records
      page
      productComparisonsMetrics {
        product {
          sku
          name
        }
        current_value
        reference_value
        change_percentage
      }
    }
  }
`
